import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ThorView } from '@aviv-dxp/react-thor';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { APP_ENV } from '@utils/constants';
import { useShortBrand } from '../../contexts/brandConfiguration/hooks';
const VIEW_PROPS = {
    av_pagetitle: 'property_estimation_housevalue',
    av_url_path: '/anbieten/hauswert-ermitteln/',
    av_category: 'estimate',
    av_environment: APP_ENV,
    av_language: 'de',
    av_plateform: 'web',
    av_site: 'IWT',
};
export const TrackingView = () => {
    const shortBrand = useShortBrand();
    const { locale } = useLocale();
    const [viewProps, setViewProps] = useState({});
    useEffect(() => {
        setViewProps({
            ...VIEW_PROPS,
            av_language: locale,
            av_site: shortBrand,
        });
    }, [shortBrand, locale]);
    if (Object.entries(viewProps).length === 0)
        return null;
    return _jsx(ThorView, { viewProps: viewProps });
};
